import { computed, ref } from 'vue'

export default function () {
  const REQUIRED_SELECTION_AMOUNT = 3
  const defaultOptions = [
    { label: '公司管理作業系統(例如ERP, ISO等)', value: 0 },
    { label: '風險管理與緊急應變', value: 0 },
    { label: '資訊安全管理', value: 0 },
    { label: '供應商管理', value: 0 },
    { label: '尊重人權', value: 0 },
    { label: '員工組成多元化', value: 0 },
    { label: '職業安全衛生', value: 0 },
    { label: '社會公益', value: 0 },
    { label: '溫室氣體盤查與能源使用', value: 0 },
    { label: '污染防制(空氣，水污染等)', value: 0 },
    { label: '氣候相關風險與機會財務衝擊', value: 0 },
    { label: '廢棄物產生與處理', value: 0 },
  ]
  const sortOptions = ref([...defaultOptions])
  const sortSelections = ref([])
  const groupOption = computed(() => {
    return {
      value: null,
      name: 'question10',
      pull: true,
      put: sortSelections.value.length < REQUIRED_SELECTION_AMOUNT,
    }
  })
  const add = (element) => {
    if (sortSelections.value.length >= REQUIRED_SELECTION_AMOUNT) return
    const id = sortOptions.value.findIndex(
      (option) => option.label === element.label,
    )
    const target = sortOptions.value.splice(id, 1)
    sortSelections.value.push(...target)
  }

  const remove = (element) => {
    const id = sortSelections.value.findIndex(
      (option) => option.label === element.label,
    )
    const target = sortSelections.value.splice(id, 1)
    sortOptions.value.push(...target)
  }

  const reset = () => {
    sortOptions.value = [...defaultOptions]
    sortSelections.value = []
  }

  return {
    REQUIRED_SELECTION_AMOUNT,
    sortOptions,
    sortSelections,
    groupOption,
    add,
    remove,
    reset,
  }
}
